import { makeAutoObservable } from 'mobx'
import Configuration from 'src/models/Configuration'
import * as apiClient from 'src/utils/apiClient/configurations'

export default class ConfigurationStore {
  private _configurations = new Configuration()

  // Getters ------------

  get configurations() {
    return this._configurations
  }

  // Constructor ------------

  constructor() {
    makeAutoObservable(this)
  }

  // Setters ------------

  setConfigurations(value: Configuration) {
    this._configurations = value
  }

  // Actions ---------------

  get = async () => {
    const res = await apiClient.getConfigurations()
    const config = new Configuration(res)
    this.setConfigurations(config)
    return config
  }
}
